/* kic-reveal.js - Wave B comp 26-27 theme-port.
   IntersectionObserver gate for .kic-reveal elements with three primitives:
   --lift, --wipe, --scale. Above-fold elements marked
   data-reveal-priority="hold" never animate. prefers-reduced-motion: reduce
   sets data-revealed=true immediately on first paint. */
(function () {
  'use strict';

  function reveal(elements) {
    elements.forEach(function (el) {
      el.setAttribute('data-revealed', 'true');
    });
  }

  function init() {
    var els = document.querySelectorAll('.kic-reveal');
    if (!els.length) return;

    // Holds: never animate.
    var holds = [];
    var observable = [];
    els.forEach(function (el) {
      if (el.getAttribute('data-reveal-priority') === 'hold') {
        holds.push(el);
      } else {
        observable.push(el);
      }
    });
    reveal(holds);

    var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      reveal(observable);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-revealed', 'true');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    observable.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
